import { combineReducers } from 'redux';
import list from './list';
import send from './send';

export default combineReducers({
  list,
  send,
});
